import Vue from 'vue'
import VueI18n from 'vue-i18n'

import English from './en/main'
import Dutch from './nl/main'
import axios from "axios";

Vue.use(VueI18n);

const messages = {'en': English, 'nl': Dutch};

export function loadAsyncLanguages (translations, lang = 'en') {
    for (let language in translations) i18n.setLocaleMessage(language, translations[language])

    return Promise.resolve(setLanguage(lang));
}

export function setLanguage (lang) {
    i18n.locale = lang;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
    return lang
}

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en',
    messages, // set locale messages
});

export default i18n;
